/**
 * @generated SignedSource<<6ca8efc579010b50e7c680989fcb410b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StaffDirectoryViewQuery$variables = {
  cloudId: string;
  first?: number | null;
  isBrowseAllScreen: boolean;
  isSearchAllScreen: boolean;
  isSearchKudosScreen: boolean;
  isVerifiedTeamsInForYouEnabled: boolean;
  kudosEnabled: boolean;
  kudosQuery: string;
  organisationId: string;
  recommendedTeamsQuery: string;
  teamQuery: string;
  userQuery: string;
  workspaceId: string;
};
export type StaffDirectoryViewQuery$data = {
  readonly explainKudosTql?: {
    readonly explanation: string | null;
  } | null;
  readonly explainUserTql?: {
    readonly explanation: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"BrowseAllScreenQuery" | "SearchAllScreen_data" | "SearchKudosScreen_data">;
};
export type StaffDirectoryViewQuery = {
  response: StaffDirectoryViewQuery$data;
  variables: StaffDirectoryViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBrowseAllScreen"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchAllScreen"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isSearchKudosScreen"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVerifiedTeamsInForYouEnabled"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosEnabled"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kudosQuery"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "organisationId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recommendedTeamsQuery"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamQuery"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userQuery"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v13 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "userQuery"
},
v14 = [
  {
    "kind": "ScalarField",
    "name": "explanation"
  }
],
v15 = {
  "condition": "isSearchKudosScreen",
  "kind": "Condition",
  "passingValue": false,
  "selections": [
    {
      "alias": "explainUserTql",
      "args": [
        {
          "kind": "Literal",
          "name": "entity",
          "value": "PERSON"
        },
        (v13/*: any*/)
      ],
      "concreteType": "TQLExplanation",
      "kind": "LinkedField",
      "name": "explainTql",
      "plural": false,
      "selections": (v14/*: any*/)
    }
  ]
},
v16 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "kudosQuery"
},
v17 = {
  "alias": "explainKudosTql",
  "args": [
    {
      "kind": "Literal",
      "name": "entity",
      "value": "KUDOS"
    },
    (v16/*: any*/)
  ],
  "concreteType": "TQLExplanation",
  "kind": "LinkedField",
  "name": "explainTql",
  "plural": false,
  "selections": (v14/*: any*/)
},
v18 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v19 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v20 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v21 = {
  "kind": "Literal",
  "name": "first",
  "value": 4
},
v22 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v23 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  (v16/*: any*/),
  (v22/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v25 = {
  "kind": "ScalarField",
  "name": "ari"
},
v26 = {
  "kind": "ScalarField",
  "name": "description"
},
v27 = {
  "kind": "ScalarField",
  "name": "imageUrl"
},
v28 = {
  "kind": "ScalarField",
  "name": "stillImageUrl"
},
v29 = {
  "kind": "ScalarField",
  "name": "type"
},
v30 = {
  "kind": "ScalarField",
  "name": "bgTheme"
},
v31 = {
  "kind": "ScalarField",
  "name": "name"
},
v32 = {
  "kind": "ScalarField",
  "name": "picture"
},
v33 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v34 = {
  "kind": "ScalarField",
  "name": "id"
},
v35 = {
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "giver",
  "plural": false,
  "selections": [
    {
      "concreteType": "UserPII",
      "kind": "LinkedField",
      "name": "pii",
      "plural": false,
      "selections": [
        (v31/*: any*/),
        (v32/*: any*/),
        (v33/*: any*/)
      ]
    },
    (v34/*: any*/)
  ]
},
v36 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "KudosRecipientConnection",
  "kind": "LinkedField",
  "name": "recipients",
  "plural": false,
  "selections": [
    {
      "concreteType": "KudosRecipientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "KudosRecipient",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "recipient",
              "plural": false,
              "selections": [
                {
                  "concreteType": "UserPII",
                  "kind": "LinkedField",
                  "name": "pii",
                  "plural": false,
                  "selections": [
                    (v33/*: any*/),
                    (v31/*: any*/),
                    (v32/*: any*/)
                  ]
                },
                (v34/*: any*/)
              ]
            },
            {
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "team",
              "plural": false,
              "selections": [
                (v31/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "teamId"
                },
                {
                  "kind": "ScalarField",
                  "name": "avatarUrl"
                },
                (v34/*: any*/)
              ]
            },
            (v34/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "recipients(first:1)"
},
v37 = {
  "kind": "Variable",
  "name": "q",
  "variableName": "teamQuery"
},
v38 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v39 = {
  "kind": "ScalarField",
  "name": "isVerified"
},
v40 = {
  "kind": "ScalarField",
  "name": "smallAvatarImageUrl"
},
v41 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v31/*: any*/),
    (v32/*: any*/)
  ]
},
v42 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v43 = {
  "kind": "Literal",
  "name": "sort",
  "value": [
    "NAME_ASC"
  ]
},
v44 = [
  {
    "concreteType": "TeamSearchResponseEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TeamSearchResponse",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v34/*: any*/),
          (v38/*: any*/),
          (v26/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          {
            "concreteType": "TeamMemberConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamMemberEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamMember",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v42/*: any*/),
                      (v41/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/)
    ],
    "kind": "Fragment",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v15/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v17/*: any*/)
        ]
      },
      {
        "args": [
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "kind": "Variable",
            "name": "isSearchAllScreen",
            "variableName": "isSearchAllScreen"
          },
          (v20/*: any*/),
          {
            "kind": "Variable",
            "name": "teamQuery",
            "variableName": "teamQuery"
          },
          {
            "kind": "Variable",
            "name": "userQuery",
            "variableName": "userQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "SearchAllScreen_data"
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v18/*: any*/),
              (v21/*: any*/),
              {
                "kind": "Variable",
                "name": "isVerifiedTeamsInForYouEnabled",
                "variableName": "isVerifiedTeamsInForYouEnabled"
              },
              {
                "kind": "Variable",
                "name": "kudosEnabled",
                "variableName": "kudosEnabled"
              },
              {
                "kind": "Literal",
                "name": "kudosFirst",
                "value": 5
              },
              {
                "kind": "Variable",
                "name": "kudosQuery",
                "variableName": "kudosQuery"
              },
              (v20/*: any*/),
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "teamQuery"
              },
              {
                "kind": "Variable",
                "name": "recommendedTeamsQuery",
                "variableName": "recommendedTeamsQuery"
              },
              (v22/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "BrowseAllScreenQuery"
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "isSearchKudosScreen",
            "variableName": "isSearchKudosScreen"
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "kudosQuery"
          },
          (v22/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "SearchKudosScreen_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v10/*: any*/),
      (v11/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v12/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "StaffDirectoryViewQuery",
    "selections": [
      (v15/*: any*/),
      {
        "condition": "isSearchKudosScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          (v17/*: any*/),
          {
            "args": (v23/*: any*/),
            "concreteType": "KudosConnection",
            "kind": "LinkedField",
            "name": "kudosTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "KudosEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Kudos",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v30/*: any*/),
                      (v35/*: any*/),
                      (v36/*: any*/),
                      (v34/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              }
            ]
          },
          {
            "args": (v23/*: any*/),
            "filters": [
              "q",
              "workspaceId"
            ],
            "handle": "connection",
            "key": "SearchKudosScreen_kudosTql",
            "kind": "LinkedHandle",
            "name": "kudosTql"
          }
        ]
      },
      {
        "condition": "isSearchAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v13/*: any*/)
            ],
            "concreteType": "CpusSearchUserConnection",
            "kind": "LinkedField",
            "name": "peopleTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "CpusSearchUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "CpusSearchUser",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "account_id"
                      },
                      (v31/*: any*/),
                      {
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "size",
                            "value": "MEDIUM"
                          }
                        ],
                        "concreteType": "HighResolutionProfilePicture",
                        "kind": "LinkedField",
                        "name": "highResolutionProfilePicture",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "url"
                          }
                        ],
                        "storageKey": "highResolutionProfilePicture(size:\"MEDIUM\")"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "job_title"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "location"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "zoneinfo"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "searchTeams",
            "args": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v37/*: any*/)
            ],
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": [
              {
                "concreteType": "TeamSearchResponseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TeamSearchResponse",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v26/*: any*/),
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "largeAvatarImageUrl"
                      },
                      {
                        "concreteType": "TeamMemberConnection",
                        "kind": "LinkedField",
                        "name": "members",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TeamMemberEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamMember",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v41/*: any*/),
                                  (v42/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "isBrowseAllScreen",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "browseTeams",
            "args": [
              (v18/*: any*/),
              (v21/*: any*/),
              (v20/*: any*/),
              (v37/*: any*/),
              (v43/*: any*/)
            ],
            "concreteType": "TeamSearchResponseConnection",
            "kind": "LinkedField",
            "name": "teamsTql",
            "plural": false,
            "selections": (v44/*: any*/)
          },
          {
            "condition": "isVerifiedTeamsInForYouEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "recommendedTeams",
                "args": [
                  (v18/*: any*/),
                  (v21/*: any*/),
                  (v20/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "q",
                    "variableName": "recommendedTeamsQuery"
                  },
                  (v43/*: any*/)
                ],
                "concreteType": "TeamSearchResponseConnection",
                "kind": "LinkedField",
                "name": "teamsTql",
                "plural": false,
                "selections": (v44/*: any*/)
              }
            ]
          },
          {
            "condition": "kudosEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "kudos",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 5
                  },
                  (v16/*: any*/),
                  (v22/*: any*/)
                ],
                "concreteType": "KudosConnection",
                "kind": "LinkedField",
                "name": "kudosTql",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "KudosEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Kudos",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v24/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/),
                          (v34/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b9d41300a647a45aab3a8daab8fbd128",
    "id": null,
    "metadata": {},
    "name": "StaffDirectoryViewQuery",
    "operationKind": "query",
    "text": "query StaffDirectoryViewQuery(\n  $teamQuery: String!\n  $userQuery: String!\n  $kudosQuery: String!\n  $first: Int\n  $organisationId: String!\n  $workspaceId: ID!\n  $cloudId: String!\n  $isSearchAllScreen: Boolean!\n  $isBrowseAllScreen: Boolean!\n  $isSearchKudosScreen: Boolean!\n  $kudosEnabled: Boolean!\n  $recommendedTeamsQuery: String!\n  $isVerifiedTeamsInForYouEnabled: Boolean!\n) {\n  explainUserTql: explainTql(q: $userQuery, entity: PERSON) @skip(if: $isSearchKudosScreen) {\n    explanation\n  }\n  explainKudosTql: explainTql(q: $kudosQuery, entity: KUDOS) @include(if: $isSearchKudosScreen) {\n    explanation\n  }\n  ...SearchAllScreen_data_JbUE\n  ...BrowseAllScreenQuery_3jX6p @include(if: $isBrowseAllScreen)\n  ...SearchKudosScreen_data_4d2Pna\n}\n\nfragment BrowseAllScreenQuery_3jX6p on Query {\n  ...BrowseTeamSection_hhH2y\n  ...BrowseKudosSection_POC2h @include(if: $kudosEnabled)\n}\n\nfragment BrowseKudosSection_POC2h on Query {\n  kudos: kudosTql(workspaceId: $workspaceId, q: $kudosQuery, first: 5) {\n    edges {\n      node {\n        ...KudosContent\n        id\n      }\n    }\n  }\n}\n\nfragment BrowseTeamSection_hhH2y on Query {\n  browseTeams: teamsTql(q: $teamQuery, first: 4, sort: [NAME_ASC], organisationId: $organisationId, cloudId: $cloudId) {\n    edges {\n      node {\n        id\n        ...TeamCard\n      }\n    }\n  }\n  recommendedTeams: teamsTql(q: $recommendedTeamsQuery, first: 4, sort: [NAME_ASC], organisationId: $organisationId, cloudId: $cloudId) @include(if: $isVerifiedTeamsInForYouEnabled) {\n    edges {\n      node {\n        id\n        ...TeamCard\n      }\n    }\n  }\n}\n\nfragment KudosContent on Kudos {\n  uuid\n  ari\n  description\n  imageUrl\n  stillImageUrl\n  type\n  bgTheme\n  giver {\n    pii {\n      name\n      picture\n      accountId\n    }\n    id\n  }\n  recipients(first: 1) {\n    edges {\n      node {\n        recipient {\n          pii {\n            accountId\n            name\n            picture\n          }\n          id\n        }\n        team {\n          name\n          teamId\n          avatarUrl\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment PersonSearchResultCard on CpusSearchUser {\n  account_id\n  name\n  highResolutionProfilePicture(size: MEDIUM) {\n    url\n  }\n  job_title\n  location\n  zoneinfo\n}\n\nfragment SearchAllScreen_data_JbUE on Query {\n  peopleTql(q: $userQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        account_id\n        ...PersonSearchResultCard\n      }\n    }\n  }\n  searchTeams: teamsTql(q: $teamQuery, organisationId: $organisationId, cloudId: $cloudId, first: $first) @include(if: $isSearchAllScreen) {\n    edges {\n      node {\n        id\n        ...TeamSearchResultCard\n      }\n    }\n  }\n}\n\nfragment SearchKudosScreen_data_4d2Pna on Query {\n  kudosTql(q: $kudosQuery, workspaceId: $workspaceId, first: 12) @include(if: $isSearchKudosScreen) {\n    edges {\n      node {\n        ...KudosContent\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TeamCard on TeamSearchResponse {\n  id\n  displayName\n  description\n  isVerified\n  smallAvatarImageUrl\n  members {\n    edges {\n      node {\n        aaid\n        pii {\n          name\n          picture\n        }\n      }\n    }\n  }\n}\n\nfragment TeamSearchAvatar on TeamSearchResponse {\n  id\n  displayName\n  isVerified\n  largeAvatarImageUrl\n}\n\nfragment TeamSearchResultCard on TeamSearchResponse {\n  id\n  description\n  displayName\n  isVerified\n  smallAvatarImageUrl\n  ...TeamSearchAvatar\n  members {\n    edges {\n      node {\n        pii {\n          name\n          picture\n        }\n        aaid\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "86ab6645c63a0c4c53b2161f37d09210";

export default node;
